import {
  Companion_getInstance1plstrcui6kcy as Companion_getInstance,
  FunnelInstance3u6ziddd47o20 as FunnelInstance,
} from './models.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareFunnelInstanceFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [FunnelInstance__id_getInstance(), FunnelInstance_funnel_getInstance(), FunnelInstance_userAgent_getInstance(), FunnelInstance_user_getInstance(), FunnelInstance_version_getInstance(), FunnelInstance_errors_getInstance(), FunnelInstance_step_getInstance(), FunnelInstance_success_getInstance(), FunnelInstance_started_getInstance(), FunnelInstance_expiry_getInstance(), FunnelInstance_expectedErrorRate_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function FunnelInstance__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function FunnelInstance__id$_get_name_$ref_uhslm5() {
  return (p0) => p0.i20();
}
function FunnelInstance__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance__id$_get_serializer_$ref_jqrqm2() {
  return (p0) => p0.h2j();
}
function FunnelInstance__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function FunnelInstance__id$_get_annotations_$ref_b4fi9q() {
  return (p0) => p0.bz();
}
var FunnelInstance__idClass;
function FunnelInstance__id() {
  if (FunnelInstance__idClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance__id_instance = this;
        var tmp = this;
        tmp.r39_1 = lazy(FunnelInstance__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s39_1 = lazy(FunnelInstance__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t39_1 = lazy(FunnelInstance__id$annotations$delegate$lambda);
        this.u39_1 = Companion_getInstance_0().k2p();
        this.v39_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.r39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance__id$_get_name_$ref_uhslm5(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.x39_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      i3a(receiver, value) {
        return receiver.j3a(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.i3a(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance__id$_get_serializer_$ref_jqrqm2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance__id$_get_annotations_$ref_b4fi9q(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance__id', VOID, VOID, [SerializableProperty()]);
    FunnelInstance__idClass = $;
  }
  return FunnelInstance__idClass;
}
var FunnelInstance__id_instance;
function FunnelInstance__id_getInstance() {
  if (FunnelInstance__id_instance === VOID)
    new (FunnelInstance__id())();
  return FunnelInstance__id_instance;
}
function FunnelInstance_funnel$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function FunnelInstance_funnel$_get_name_$ref_8035yv() {
  return (p0) => p0.i20();
}
function FunnelInstance_funnel$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_funnel$_get_serializer_$ref_houbby() {
  return (p0) => p0.h2j();
}
function FunnelInstance_funnel$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function FunnelInstance_funnel$_get_annotations_$ref_3r3m02() {
  return (p0) => p0.bz();
}
var FunnelInstance_funnelClass;
function FunnelInstance_funnel() {
  if (FunnelInstance_funnelClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_funnel_instance = this;
        var tmp = this;
        tmp.k3a_1 = lazy(FunnelInstance_funnel$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l3a_1 = lazy(FunnelInstance_funnel$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m3a_1 = lazy(FunnelInstance_funnel$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.k3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_funnel$_get_name_$ref_8035yv(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.y39_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      n3a(receiver, value) {
        return receiver.j3a(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.n3a(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_funnel$_get_serializer_$ref_houbby(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_funnel$_get_annotations_$ref_3r3m02(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_funnel', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_funnelClass = $;
  }
  return FunnelInstance_funnelClass;
}
var FunnelInstance_funnel_instance;
function FunnelInstance_funnel_getInstance() {
  if (FunnelInstance_funnel_instance === VOID)
    new (FunnelInstance_funnel())();
  return FunnelInstance_funnel_instance;
}
function FunnelInstance_userAgent$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function FunnelInstance_userAgent$_get_name_$ref_d8hivn() {
  return (p0) => p0.i20();
}
function FunnelInstance_userAgent$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_userAgent$_get_serializer_$ref_xrfd52() {
  return (p0) => p0.h2j();
}
function FunnelInstance_userAgent$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function FunnelInstance_userAgent$_get_annotations_$ref_yy5ksi() {
  return (p0) => p0.bz();
}
var FunnelInstance_userAgentClass;
function FunnelInstance_userAgent() {
  if (FunnelInstance_userAgentClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_userAgent_instance = this;
        var tmp = this;
        tmp.o3a_1 = lazy(FunnelInstance_userAgent$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p3a_1 = lazy(FunnelInstance_userAgent$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q3a_1 = lazy(FunnelInstance_userAgent$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.o3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_userAgent$_get_name_$ref_d8hivn(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.z39_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      n3a(receiver, value) {
        return receiver.j3a(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.n3a(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_userAgent$_get_serializer_$ref_xrfd52(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_userAgent$_get_annotations_$ref_yy5ksi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_userAgent', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_userAgentClass = $;
  }
  return FunnelInstance_userAgentClass;
}
var FunnelInstance_userAgent_instance;
function FunnelInstance_userAgent_getInstance() {
  if (FunnelInstance_userAgent_instance === VOID)
    new (FunnelInstance_userAgent())();
  return FunnelInstance_userAgent_instance;
}
function FunnelInstance_user$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function FunnelInstance_user$_get_name_$ref_sb071o() {
  return (p0) => p0.i20();
}
function FunnelInstance_user$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_user$_get_serializer_$ref_us9mb1() {
  return (p0) => p0.h2j();
}
function FunnelInstance_user$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function FunnelInstance_user$_get_annotations_$ref_eu4fav() {
  return (p0) => p0.bz();
}
var FunnelInstance_userClass;
function FunnelInstance_user() {
  if (FunnelInstance_userClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_user_instance = this;
        var tmp = this;
        tmp.r3a_1 = lazy(FunnelInstance_user$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s3a_1 = lazy(FunnelInstance_user$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t3a_1 = lazy(FunnelInstance_user$annotations$delegate$lambda);
        this.u3a_1 = null;
        this.v3a_1 = 'null';
      }
      i20() {
        var tmp0 = this.r3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_user$_get_name_$ref_sb071o(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.a3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      w3a(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.w3a(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_user$_get_serializer_$ref_us9mb1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_user$_get_annotations_$ref_eu4fav(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_user', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_userClass = $;
  }
  return FunnelInstance_userClass;
}
var FunnelInstance_user_instance;
function FunnelInstance_user_getInstance() {
  if (FunnelInstance_user_instance === VOID)
    new (FunnelInstance_user())();
  return FunnelInstance_user_instance;
}
function FunnelInstance_version$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function FunnelInstance_version$_get_name_$ref_8g9kdt() {
  return (p0) => p0.i20();
}
function FunnelInstance_version$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_version$_get_serializer_$ref_qyjhzs() {
  return (p0) => p0.h2j();
}
function FunnelInstance_version$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function FunnelInstance_version$_get_annotations_$ref_iv3do() {
  return (p0) => p0.bz();
}
var FunnelInstance_versionClass;
function FunnelInstance_version() {
  if (FunnelInstance_versionClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_version_instance = this;
        var tmp = this;
        tmp.x3a_1 = lazy(FunnelInstance_version$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y3a_1 = lazy(FunnelInstance_version$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z3a_1 = lazy(FunnelInstance_version$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.x3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_version$_get_name_$ref_8g9kdt(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.b3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      n3a(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.n3a(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_version$_get_serializer_$ref_qyjhzs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z3a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_version$_get_annotations_$ref_iv3do(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_version', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_versionClass = $;
  }
  return FunnelInstance_versionClass;
}
var FunnelInstance_version_instance;
function FunnelInstance_version_getInstance() {
  if (FunnelInstance_version_instance === VOID)
    new (FunnelInstance_version())();
  return FunnelInstance_version_instance;
}
function FunnelInstance_errors$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function FunnelInstance_errors$_get_name_$ref_q81pdg() {
  return (p0) => p0.i20();
}
function FunnelInstance_errors$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_errors$_get_serializer_$ref_35u31() {
  return (p0) => p0.h2j();
}
function FunnelInstance_errors$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function FunnelInstance_errors$_get_annotations_$ref_ddo5wp() {
  return (p0) => p0.bz();
}
var FunnelInstance_errorsClass;
function FunnelInstance_errors() {
  if (FunnelInstance_errorsClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_errors_instance = this;
        var tmp = this;
        tmp.a3b_1 = lazy(FunnelInstance_errors$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b3b_1 = lazy(FunnelInstance_errors$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c3b_1 = lazy(FunnelInstance_errors$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.setOf' call
        tmp_2.d3b_1 = emptySet();
        this.e3b_1 = 'setOf()';
      }
      i20() {
        var tmp0 = this.a3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_errors$_get_name_$ref_q81pdg(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.c3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      f3b(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.f3b(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.b3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_errors$_get_serializer_$ref_35u31(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_errors$_get_annotations_$ref_ddo5wp(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_errors', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_errorsClass = $;
  }
  return FunnelInstance_errorsClass;
}
var FunnelInstance_errors_instance;
function FunnelInstance_errors_getInstance() {
  if (FunnelInstance_errors_instance === VOID)
    new (FunnelInstance_errors())();
  return FunnelInstance_errors_instance;
}
function FunnelInstance_step$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function FunnelInstance_step$_get_name_$ref_u1pv() {
  return (p0) => p0.i20();
}
function FunnelInstance_step$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_step$_get_serializer_$ref_nqe66k() {
  return (p0) => p0.h2j();
}
function FunnelInstance_step$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function FunnelInstance_step$_get_annotations_$ref_9bdpdk() {
  return (p0) => p0.bz();
}
var FunnelInstance_stepClass;
function FunnelInstance_step() {
  if (FunnelInstance_stepClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_step_instance = this;
        var tmp = this;
        tmp.g3b_1 = lazy(FunnelInstance_step$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h3b_1 = lazy(FunnelInstance_step$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i3b_1 = lazy(FunnelInstance_step$annotations$delegate$lambda);
        this.j3b_1 = 0;
        this.k3b_1 = '0';
      }
      i20() {
        var tmp0 = this.g3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_step$_get_name_$ref_u1pv(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.d3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      l3b(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.l3b(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_step$_get_serializer_$ref_nqe66k(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_step$_get_annotations_$ref_9bdpdk(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_step', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_stepClass = $;
  }
  return FunnelInstance_stepClass;
}
var FunnelInstance_step_instance;
function FunnelInstance_step_getInstance() {
  if (FunnelInstance_step_instance === VOID)
    new (FunnelInstance_step())();
  return FunnelInstance_step_instance;
}
function FunnelInstance_success$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function FunnelInstance_success$_get_name_$ref_ihhlvo() {
  return (p0) => p0.i20();
}
function FunnelInstance_success$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_success$_get_serializer_$ref_9yyof7() {
  return (p0) => p0.h2j();
}
function FunnelInstance_success$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function FunnelInstance_success$_get_annotations_$ref_ty069z() {
  return (p0) => p0.bz();
}
var FunnelInstance_successClass;
function FunnelInstance_success() {
  if (FunnelInstance_successClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_success_instance = this;
        var tmp = this;
        tmp.m3b_1 = lazy(FunnelInstance_success$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n3b_1 = lazy(FunnelInstance_success$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o3b_1 = lazy(FunnelInstance_success$annotations$delegate$lambda);
        this.p3b_1 = null;
        this.q3b_1 = 'null';
      }
      i20() {
        var tmp0 = this.m3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_success$_get_name_$ref_ihhlvo(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.e3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      r3b(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.r3b(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_success$_get_serializer_$ref_9yyof7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_success$_get_annotations_$ref_ty069z(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_success', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_successClass = $;
  }
  return FunnelInstance_successClass;
}
var FunnelInstance_success_instance;
function FunnelInstance_success_getInstance() {
  if (FunnelInstance_success_instance === VOID)
    new (FunnelInstance_success())();
  return FunnelInstance_success_instance;
}
function FunnelInstance_started$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function FunnelInstance_started$_get_name_$ref_o9kypy() {
  return (p0) => p0.i20();
}
function FunnelInstance_started$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_started$_get_serializer_$ref_dpntwf() {
  return (p0) => p0.h2j();
}
function FunnelInstance_started$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function FunnelInstance_started$_get_annotations_$ref_h6ungb() {
  return (p0) => p0.bz();
}
var FunnelInstance_startedClass;
function FunnelInstance_started() {
  if (FunnelInstance_startedClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_started_instance = this;
        var tmp = this;
        tmp.s3b_1 = lazy(FunnelInstance_started$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t3b_1 = lazy(FunnelInstance_started$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u3b_1 = lazy(FunnelInstance_started$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.v3b_1 = get_default(Companion_instance).b1m();
        this.w3b_1 = 'now()';
      }
      i20() {
        var tmp0 = this.s3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_started$_get_name_$ref_o9kypy(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.f3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      x3b(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.x3b(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_started$_get_serializer_$ref_dpntwf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_started$_get_annotations_$ref_h6ungb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_started', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_startedClass = $;
  }
  return FunnelInstance_startedClass;
}
var FunnelInstance_started_instance;
function FunnelInstance_started_getInstance() {
  if (FunnelInstance_started_instance === VOID)
    new (FunnelInstance_started())();
  return FunnelInstance_started_instance;
}
function FunnelInstance_expiry$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function FunnelInstance_expiry$_get_name_$ref_95wcgk() {
  return (p0) => p0.i20();
}
function FunnelInstance_expiry$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_expiry$_get_serializer_$ref_ick4w5() {
  return (p0) => p0.h2j();
}
function FunnelInstance_expiry$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function FunnelInstance_expiry$_get_annotations_$ref_fj9an5() {
  return (p0) => p0.bz();
}
var FunnelInstance_expiryClass;
function FunnelInstance_expiry() {
  if (FunnelInstance_expiryClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_expiry_instance = this;
        var tmp = this;
        tmp.y3b_1 = lazy(FunnelInstance_expiry$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z3b_1 = lazy(FunnelInstance_expiry$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a3c_1 = lazy(FunnelInstance_expiry$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        var tmp_3 = get_default(Companion_instance).b1m();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance_1();
        var tmp$ret$1 = toDuration(20, DurationUnit_MINUTES_getInstance());
        tmp_2.b3c_1 = tmp_3.s26(tmp$ret$1);
        this.c3c_1 = 'now() + 20.minutes';
      }
      i20() {
        var tmp0 = this.y3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_expiry$_get_name_$ref_95wcgk(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.g3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      x3b(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.x3b(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z3b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_expiry$_get_serializer_$ref_ick4w5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a3c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_expiry$_get_annotations_$ref_fj9an5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_expiry', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_expiryClass = $;
  }
  return FunnelInstance_expiryClass;
}
var FunnelInstance_expiry_instance;
function FunnelInstance_expiry_getInstance() {
  if (FunnelInstance_expiry_instance === VOID)
    new (FunnelInstance_expiry())();
  return FunnelInstance_expiry_instance;
}
function FunnelInstance_expectedErrorRate$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function FunnelInstance_expectedErrorRate$_get_name_$ref_e7snnt() {
  return (p0) => p0.i20();
}
function FunnelInstance_expectedErrorRate$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelInstance_expectedErrorRate$_get_serializer_$ref_wml7m8() {
  return (p0) => p0.h2j();
}
function FunnelInstance_expectedErrorRate$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function FunnelInstance_expectedErrorRate$_get_annotations_$ref_wzpys() {
  return (p0) => p0.bz();
}
var FunnelInstance_expectedErrorRateClass;
function FunnelInstance_expectedErrorRate() {
  if (FunnelInstance_expectedErrorRateClass === VOID) {
    class $ {
      constructor() {
        FunnelInstance_expectedErrorRate_instance = this;
        var tmp = this;
        tmp.d3c_1 = lazy(FunnelInstance_expectedErrorRate$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e3c_1 = lazy(FunnelInstance_expectedErrorRate$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f3c_1 = lazy(FunnelInstance_expectedErrorRate$annotations$delegate$lambda);
        this.g3c_1 = 0.05;
        this.h3c_1 = '0.05f';
      }
      i20() {
        var tmp0 = this.d3c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelInstance_expectedErrorRate$_get_name_$ref_e7snnt(), null);
        return tmp0.f2();
      }
      w39(receiver) {
        return receiver.h3a_1;
      }
      k2j(receiver) {
        return this.w39(receiver instanceof FunnelInstance() ? receiver : THROW_CCE());
      }
      i3c(receiver, value) {
        return receiver.j3a(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FunnelInstance() ? receiver : THROW_CCE();
        return this.i3c(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.e3c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelInstance_expectedErrorRate$_get_serializer_$ref_wml7m8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f3c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelInstance_expectedErrorRate$_get_annotations_$ref_wzpys(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelInstance_expectedErrorRate', VOID, VOID, [SerializableProperty()]);
    FunnelInstance_expectedErrorRateClass = $;
  }
  return FunnelInstance_expectedErrorRateClass;
}
var FunnelInstance_expectedErrorRate_instance;
function FunnelInstance_expectedErrorRate_getInstance() {
  if (FunnelInstance_expectedErrorRate_instance === VOID)
    new (FunnelInstance_expectedErrorRate())();
  return FunnelInstance_expectedErrorRate_instance;
}
//region block: exports
export {
  prepareFunnelInstanceFields as prepareFunnelInstanceFields2vjcvz3qv4dsq,
};
//endregion

//# sourceMappingURL=FunnelInstanceFields.mjs.map
